import { render, staticRenderFns } from "./logger.vue?vue&type=template&id=72e1400f&scoped=true"
import script from "./logger.vue?vue&type=script&lang=js"
export * from "./logger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_n3acbem2au4l2e3t4qvos3rwwq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e1400f",
  null
  
)

export default component.exports